import * as React from 'react';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const PlacementFormComponent: React.SFC<any> = (props: any) => {
  const {
    error,
    pristine,
    handleSubmit,
    submitting,
    charities,
  } = props;
  const required = value => value ? undefined : 'Required';
  return (
    <form onSubmit={handleSubmit}>
      <div className="field">
        <label className="label">URL</label>
        <div className="control">
          <Field
            disabled={true}
            component="input"
            type="text"
            className="input"
            placeholder="URL"
            name="url"
            validate={[ required ]}
          />
          {error && <p className="help is-danger">{error}</p>}
        </div>
      </div>
      {
        !!charities &&
        <div className="columns">
          {map(charities, (charity: any, charityId: string) => (
            <div className="column is-one-fifth" key={charityId}>
              <div className="field">
                <label className="label" htmlFor={charityId.replace(/\W/g, '_')}>
                  <Field
                    name={charityId}
                    id={charityId.replace(/\W/g, '_')}
                    component="input"
                    type="checkbox"
                  />
                  &nbsp; {charity.name}
                </label>
                <figure>
                  <img className="image" src={charity.logoImgUrl} alt={charity.name}/>
                </figure>
              </div>
            </div>
          ))}
        </div>
      }

      <div className="field is-grouped">
        <div className="control">
          <Link className="button is-link" to="/placements">Back to placements</Link>
        </div>
        <div className="control">
          <button
            type="submit"
            disabled={pristine || submitting}
            className="button"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  );
};

const PlacementFormWithForm: any = reduxForm({
  form: 'placement', // a unique identifier for this form
})(PlacementFormComponent);

const mapStateToProps: any = ({ placements }) => (
  { initialValues: placements.currentlyEditingPlacement }
);

export const PlacementForm = connect(mapStateToProps)(PlacementFormWithForm) as any;
